import ValidService from "@/service/ValidService";

let model = {};

const defaultConfig = () => ({
  margin_top: 20,
  margin_bottom: 20,
  margin_left: 30,
  margin_right: 20,
  page_size: "A4",
  page_orientation: "Portrait",
});

model.dataForm = {
  name: null,
  code: null,
  dda_category_id: null,
  content: {
    header: "",
    body: "",
    footer: "",
  },
  config: defaultConfig(),
  disabled: false,
};

model.defaultConfig = defaultConfig;

model.validForm = {
  name: [ValidService.required, ValidService.checkMaxLength(150)],
  code: [
    ValidService.required,
    ValidService.checkSpaceString,
    ValidService.checkSpaceStringCenter,
    ValidService.checkMaxLength(50),
  ],
  dda_category_id: [ValidService.requiredChange],
  "content.body": [ValidService.required],
  "config.margin_top": [ValidService.required, ValidService.checkNumberInteger],
  "config.margin_bottom": [ValidService.required, ValidService.checkNumberInteger],
  "config.margin_left": [ValidService.required, ValidService.checkNumberInteger],
  "config.margin_right": [ValidService.required, ValidService.checkNumberInteger],
  "config.page_size": [ValidService.requiredChange],
  "config.page_orientation": [ValidService.requiredChange],
};

model.tableRules = {
  data: [],
  lengthMenu: [10, 20, 50, 100],
  allowPaging: true,
  allowSorting: true,
  allowSelect: false,
  showFormSearch: false,
  showUrl: true,
  total: 0,
  page: 1,
  limit: 10,
  offset: 0,
  sort: "name",
  defaultSort: ["name", "ascending"],
  filters: "",
  recordSelected: [],
  dataSearch: {
    value: {
      name: null,
      code: null,
      dda_category_id: null,
      disabled: null,
    },
    valid: {},
    operator: {
      name: "$vn_text=",
      code: ":regex_i:",
      dda_category_id: "",
      disabled: "",
    },
  },
};

export default model;
